import axios from "axios";

import { createAsyncThunk } from "@reduxjs/toolkit";

import { ga4DecryptionEndpoint } from "Constants/GA4";

export const decryptGa4Params = createAsyncThunk(
  'ga4/decryptGa4Params',
  async (ga4Params, { getState }) => {
    const { user } = getState().oidc;

    const body = {
      projectId: user.profile['custom:campaign_id'],
      data: ga4Params,
    };

    try {
      const { data: decryptedMsg } = await axios.post(`${ga4DecryptionEndpoint}/encryption/gtm/decrypt`, body);

      return decryptedMsg.data;
    } catch (err) {
      console.log('Erro ao descriptografar parâmetros do GA4', err);
    }
  }
);
